import { useSwrNoAuth } from "../../swr/useSwrNoAuth";


export const useFetchSegmentCount = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `games/roulette/restaurants/${restaurantId}/setting/segment-count/` : null;
  const { data: segmentCount, error, isLoading } = useSwrNoAuth<number>(fetcherKey)
  return { segmentCount, isLoading, error };
}